import './index.scss'

import { Button, Card, List, Select, Spin } from 'antd'
import React, { useImperativeHandle } from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'

import { numOptions } from '@api/home/detail/addCart/useAddCart'
import { useFlashSale } from '@api/home/detail/useFlashSale'
import { deleteCart, updateCart } from '@api/home/shopCart/action'
import {
  setShopGroupList,
  setShopListTotalInfo,
  useShopCartGroupList
} from '@api/home/shopCart/cartSlice'
import { ProductData } from '@api/home/shopCart/types'
import { Container, Flex, Icon, Image, Switch, Text } from '@ui-pc'
import showPopup from '@ui-pc/Popup'
import RateSnapshot from '@ui-pc/Widget/components/RateSnapshot'
import { getRelativeUrl } from '@utils'
import { Type } from '@utils/tool'

import MarketingText from '../../../Detail/components/MarketingText'
import { SkuOptionsText } from '../StatisticalPanel/index'
import { ShopEmty, showEstPoup } from './ShopEmty'

type Props = {
  dispatch: any
  item: ProductData
  leftSlot?: JSX.Element | null
  middleSlot?: JSX.Element | null
  imgProps?: any
  opratorStyle?: 'right'
  onClick?: Function
  small?: boolean
  itemIndex?: Number
}

const FlashSale = (props: { data; justify?: 'end' }) => {
  const { data = {}, justify } = props

  const { time, isActivity, isEndsIn } = useFlashSale(data)

  return (
    <Switch either={isActivity}>
      <div className="flash-box">
        <i className="iconfont icon-ic2 flash-red"></i>
        <span className="flash-text flash-red">Flash Sale</span>
        <Switch either={isEndsIn}>
          <p>
            <Text className="flash-normal-text flash-red">Ends In {'  '}</Text>
            {/* <span className="time">{time.days}</span> */}

            <Text className="flash-text flash-red">
              {time.hours.toString().padStart(2, '0')}
            </Text>
            <Text className="flash-text flash-red">:</Text>
            <Text className="flash-text flash-red">
              {time.minutes.toString().padStart(2, '0')}
            </Text>
            <Text className="flash-text flash-red">:</Text>
            <Text className="flash-text flash-red">
              {time.seconds.toString().padStart(2, '0')}
            </Text>
          </p>
          <span className="flash-normal-text flash-red">Ends Soon</span>
        </Switch>
      </div>
    </Switch>
  )
}

export const ViewCart = (props: Props) => {
  const { dispatch, small, item, imgProps = {}, onClick, itemIndex } = props

  const [loading, useLoading] = React.useState(false)

  const select = (
    <Select
      suffixIcon={<i className="iconfont icon-xiala-s icon-xiala"></i>}
      value={item.qty}
      options={numOptions(item.stock)}
      onChange={(value) => {
        useLoading(true)
        updateCart({
          addTime: item.addTime,
          cart_id: item.cartId,
          quantity: value,
          show_group: '1'
          // addTime: item.addTime
        })
          .then((res) => {
            dispatch(setShopGroupList(res))
            dispatch(setShopListTotalInfo(res))
            useLoading(false)
          })
          .finally(() => {
            useLoading(false)
          })
      }}
    />
  )

  return (
    <Spin spinning={loading}>
      <div
        className={
          small
            ? `cart-list-small cart-flex cart-list-${itemIndex}`
            : 'cart-list cart-flex'
        }>
        <div>
          <Image
            onClick={() => onClick?.()}
            placeholder
            alt={item.productsName}
            preview={false}
            src={item.imageUrl}
            className="cart-list-img"
            {...imgProps}
          />
          {small && (
            <div id="selector-box" className='cart-list-img"'>
              {select}
            </div>
          )}
        </div>
        <div className="cart-list-info">
          <div className="shop-item-top">
            {/* 标题 */}
            <p className={`cart-list-title ${small ? 'line2' : 'line1'}`}>
              {item.productsName}
            </p>
            {/* 删除 */}
            <Button
              type="text"
              icon={<Icon customSrc="icon-ic_del" size={18} />}
              className="shop-item-delete"
              onClick={() => {
                useLoading(true)
                deleteCart({
                  cart_id: item.cartId,
                  show_group: '1',
                  addTime: item.addTime
                })
                  .then((res) => {
                    dispatch(setShopGroupList(res))
                    dispatch(setShopListTotalInfo(res))
                    useLoading(false)
                  })
                  .finally(() => {
                    useLoading(false)
                  })
              }}
            />
          </div>
          <div className="shop-item-mid">
            {/* sku信息1  */}
            <div className="pro-attrs">
              <SkuOptionsText attrs={item?.attrs} />
            </div>
            <RateSnapshot
              readonly
              num={item?.starScore}
              people={item?.reviewNum}
              className="rate-area"
            />
            {/* 活动区域 */}
            <FlashSale data={item?.activityInfo} />
          </div>
          <div className="shop-item-bot">
            {/* 价格区域 */}
            <div className="shop-cart-price-qty">
              <Flex alignItems="center" span={`${small ? '100%' : '80%'}`}>
                <Text size={18} strong>
                  {item?.formatFinalPrice}
                </Text>
                <Text type="secondary" delete size={14} gap={[0, 8]}>
                  {item?.formatMarketPrice}
                </Text>
                <Text type="danger" size={14} className="save-m-gap">
                  {item?.saveMoneyDesc}
                </Text>
              </Flex>
              {!small && (
                <div id="selector-box" className="shop-cart-qty">
                  {select}
                </div>
              )}
            </div>
            <MarketingText
              isDrawer={small}
              isCart={true}
              stocks={item.stock}
              {...(item as any)}
            />
          </div>
        </div>
      </div>
      {/* <div className="marketingText-bg">
        <MarketingText
          isDrawer={small}
          isCart={true}
          stocks={item.stock}
          {...(item as any)}
        />
      </div> */}
    </Spin>
  )
}

/**
 * 购物车list抽屉组件
 */
export default function Index(props) {
  const { data = [], mode, onJump, handle = {} } = props
  const { dispatch, shopList, shopGroupList, isLoading, refetch } =
    useShopCartGroupList()
  const { productGroup } = shopGroupList

  const navigate = useNavigate()

  useImperativeHandle(handle, () => ({ refetch }))

  const jumpTo = (item) => {
    navigate(getRelativeUrl(item.url), {
      state: {
        from: '/recommend',
        id: item.skuId
      }
    })
    onJump?.()
  }

  const handleGroupLink = (url: string) => {
    const currentUrl = location.pathname + location.search
    if (url === currentUrl) {
      onJump?.()
    } else {
      navigate(url)
    }
  }

  return (
    <Container
      errorPage={
        <ShopEmty
          isCard={mode === 'card'}
          onLogin={() => {
            refetch()
          }}
        />
      }
      isLoading={isLoading}
      isError={Type.isEmpty(shopList.productList)}>
      <Switch either={mode === 'card'}>
        <>
          <Card className="view-cart-left" title={null}>
            <div className="shop-cart-head">
              <span className="shop-card-title">Shopping Cart</span>
              <div className="shop-card-title-right">
                <Icon size={20} customSrc={'icon-ic_Free2'} />
                <span className="free-ship-on">
                  Free Shipping On All Orders
                </span>
              </div>
            </div>
            {/* {shopList?.productList?.map((item) => {
              return (
                <div key={item.cartId} className="shop-card-items">
                  <ViewCart
                    item={item}
                    onClick={() => {
                      window.open(getRelativeUrl(item.url), '_blank')
                      // navigate(getRelativeUrl(item.url))
                    }}
                    dispatch={dispatch}
                    opratorStyle="right"
                  />
                </div>
              )
            })} */}
            {productGroup?.map((group) => (
              <div className="shop-cart-group">
                {group?.groupType === '2' && (
                  <div className="shop-cart-group-box">
                    <i className="iconfont icon-PC_save_1"></i>
                    <Link
                      className="shop-cart-group-link"
                      to={group?.activityUrl}>
                      <span className="text1">{group?.groupDesc}</span>
                      <i className={`iconfont icon-m_ic_jiantou`}></i>
                    </Link>
                  </div>
                )}
                {group?.groupType === '3' && (
                  <div className="shop-cart-group-tips">
                    <span className="text1">{group?.groupDesc}</span>
                  </div>
                )}
                {group?.groupType === '4' && (
                  <div className="shop-cart-group-bundle">
                    <span className="text1">{group?.groupDesc}</span>
                    <span className="text2">{group?.groupDiscount}</span>
                  </div>
                )}
                {group?.productList?.map((item) => (
                  <div key={item.cartId} className="shop-card-items">
                    <ViewCart
                      item={item}
                      onClick={() => {
                        window.open(getRelativeUrl(item.url), '_blank')
                      }}
                      dispatch={dispatch}
                      opratorStyle="right"
                    />
                  </div>
                ))}
              </div>
            ))}
          </Card>
        </>
        <List
          className="shop-cart-list"
          grid={{ column: 1 }}
          style={{ background: 'white' }}
          itemLayout="horizontal"
          dataSource={productGroup || []}
          renderItem={(item: any, index: number) => {
            return (
              <>
                <div className="shop-cart-group">
                  {item?.groupType === '2' && (
                    <div className="shop-cart-group-box">
                      <i className="iconfont icon-PC_save_1"></i>
                      <div
                        className="shop-cart-group-link"
                        onClick={() =>
                          handleGroupLink(getRelativeUrl(item?.activityUrl))
                        }>
                        <span className="text1">{item?.groupDesc}</span>
                        <i className={`iconfont icon-m_ic_jiantou`}></i>
                      </div>
                    </div>
                  )}
                  {item?.groupType === '3' && (
                    <div className="shop-cart-group-tips">
                      <span className="text1">{item?.groupDesc}</span>
                    </div>
                  )}
                  {item?.groupType === '4' && (
                    <div className="shop-cart-group-bundle">
                      <span className="text1">{item?.groupDesc}</span>
                      <span className="text2">{item?.groupDiscount}</span>
                    </div>
                  )}
                  {item?.productList?.map((ele, idx) => (
                    <div key={ele.cartId} className="shop-card-items">
                      <ViewCart
                        small={true}
                        item={ele}
                        itemIndex={idx}
                        dispatch={dispatch}
                        onClick={() => jumpTo(ele)}
                      />
                    </div>
                  ))}
                </div>
              </>
            )
          }}
        />
      </Switch>
    </Container>
  )
}
